import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import HomePage from "@system/config/home-page";
import System from "src/helper/system";
import useReduxState from "src/hooks/useReduxState";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import Common from "./Common";
import SystemAlerts from "../../component/SystemAlerts";
import { useSelector } from "react-redux";
import { useHomePageContentStore } from "../../hooks/HomePageContent";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import Product from "@system/config/product";

let c = System.getParams();

const HomePageTabsListing = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const homeTabType = System.getParams().__c_HomeTabList;
  const [selectedTab, setSelectedTab] = useReduxState("PLT", "searchParams");
  const [searchParams] = useSearchParams();
  const [{ allTabsCount }, { get_all_tab_count }] = useHomePageContentStore();
  const [searchContentEventDetected, setSearchContentEventDetected] = useState(false);
  const [countCallStatus, set_countCallStatus] = useReduxState(false, "HomePageTabsListing_countCallStatus");
  // 16933 - Need to remove trailing slash condition - PN - 16/2/2024
  const [HomeTabList__Component__Loader, Set_HomeTabList__Component__Loader] = useReduxState(
    searchParams.get(Common.param_key_HomeTabList) ? searchParams.get(Common.param_key_HomeTabList).replace(/\/$/, "") : Common.default_component.param_value, Common.redux_key_HomeTabList
  );
  const [tempTab, setTempTab] = useState();
  const [listingAPICallLoader] = useReduxState(false, 'product_listing_listingAPICallLoader');
  const list = useSelector((state) => state.entities.ProductListingAPICall.data);
  const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedContentFilterList');
  const [filterFacets, setFilterFacets] = useReduxState([], 'setContentFilterFacets');
  const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
  // const listCnt = Common.getContentTabValueFromStore('productListingCount')

  const getActiveClass = (singleElement) => {
    if (Common.chain_HomeTabList[HomeTabList__Component__Loader].param_value === singleElement.param_value) {
      return "active";
    }
    return "";
  };
  const getTabLink = (singleElement) => {
    return HomePage.getHomeTabsListRouteURL({
      ...c,
      [Common.param_key_HomeTabList]: singleElement.param_value,
    });
  };

  const switchTab = async (url, chain_single) => {
    setSelectedFilterList([])
    setFilterFacets([])
    history.pushState("", "", url);
    // 16933 - Need to remove trailing slash condition - PN - 16/2/2024
    Set_HomeTabList__Component__Loader(chain_single.param_value.replace(/\/$/, ""));
  };

  useEffect(() => {
    async function fetchHere() {
      let bom_plp_mode_detected;
      if (props.isBomPLP !== undefined && props.isBomPLP === "yes") {
        bom_plp_mode_detected = true;
      }
      if (props.addToBOMSwapModeByBomDetailID !== undefined && props.addToBOMSwapModeByBomDetailID === "yes") {
        bom_plp_mode_detected = true;
      }
      if (bom_plp_mode_detected === false && searchParams.get(Common.param_key_HomeTabList) !== Common.default_component.param_value) {
        if (c.search === undefined) {
          window.location.href = getTabLink(Common.default_component);
        }
        if (c.search !== undefined && c.search.length < 2) {
          window.location.href = getTabLink(Common.default_component);
        }
      }
      set_countCallStatus(true);
      const _defaultTab = homeTabType;

      let _homeTabType = _defaultTab !== undefined ? _defaultTab : "PLT";
      // let _homeTabType = "PLT";
      // if (_defaultTab) {
      //   _homeTabType = _defaultTab;
      //   setTempTab(_defaultTab)
      // }
      setSelectedTab(_homeTabType);

      if (bom_plp_mode_detected !== true && c.search !== undefined && c.search.length > 1) {
        setSearchContentEventDetected(true);
      }
      if (c.search) {
        const params = { searchParam: c.search, currentTab: _homeTabType };
        await get_all_tab_count(params);
        if (_defaultTab) {
          let v = {}
          v.param_value = _defaultTab
          await switchTab(getTabLink(v), v);
          setTempTab(_defaultTab)
        } else { setTempTab("") }
      }
      // Search CAll over
    }

    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectedTab(homeTabType !== undefined ? homeTabType : "PLT");
    }

    fetchHere();
  }, [homeTabType]);


  useEffect(() => {
    async function fetchHere() {
      if (tempTab !== undefined && listingAPICallLoader) {
        let v = {};
        const lstCnt = Common.getContentTabValueFromStore('productListingCount')?.count;
        if (lstCnt && lstCnt > 0) {
          v.param_value = 'PLT'
          await switchTab(getTabLink(v), v);
        }
        // Hide Content Tab
        else if (allTabsCount.npiCount > 0) {
          v.param_value = 'NPIT'
          await switchTab(getTabLink(v), v);
        }
        else if (allTabsCount.contentCount > 0) {
          v.param_value = 'CNT'
          await switchTab(getTabLink(v), v);
        }
        else if (allTabsCount.documentCount > 0) {
          v.param_value = 'DCT'
          await switchTab(getTabLink(v), v);
        } else {
          //DT - 27/9 - 13142 - update when no content found
          // window.location.href = Common.getRedirectionURL(c.search, list, allTabsCount, c);
          delete c.go;
          delete c.search;
          localStorage.removeItem('product_listing_page')
          localStorage.removeItem('product_listing_limit')
          history.pushState(null, null, '?' + $.param(c));
          window.location.href = Product.getProductListingNotFoundPageRouteURL() + '?' + $.param(c);
        }
        v.param_value && setTempTab(v.param_value)
      }
    }
    fetchHere();
  }, [listingAPICallLoader, tempTab])

  /**
   * Author : Pankaj
   * Date   : 26-09-2023
   * Reason : Hide DX Loader once our component loads.
   */
  React.useEffect(() => {
    if (document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
      document.getElementsByClassName('snippet')[0].style.display = 'none';
    }
  }, [])

  return (
    <>
      {!(props.isBomPLP !== undefined && props.isBomPLP === "yes") &&
        searchContentEventDetected === true && (
          <div className="container">
            {
              latest_system_notification_data.errorModule !== undefined &&
              latest_system_notification_data.errorModule !== 'exportMsg' &&
              <div className="mt-2">
                <SystemAlerts />
              </div>
            }

            <ul className="bs5 nav nav-tabs">
              {Object.entries(Common.chain_HomeTabList).map((v) => (
                <React.Fragment key={v[1].name}>
                  <li className="bs5 nav-item" key={v[1].name}>
                    <a className={"nav-link " + getActiveClass(v[1])}
                      href={void 0}
                      onClick={async () => {
                        System.clearAllAlert();
                        await switchTab(getTabLink(v[1]), v[1]);
                      }}
                    >
                      <span>
                        {/**
                         * Tmparary we make condition for count if get more than 100000 then display 100000
                         * Author: Devanshi patel
                         */}
                        {v[1].name}{" "}{'(' + (v[1].store().count > 100000 ? 100000 : v[1].store().count) + ')'}
                        {/* {!__check("ALL_COUNT_API_CALL").status
                          ? `(${v[1].store().count})`
                          : null} */}
                      </span>
                    </a>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        )}
      <div className="search-page-tab mobile-tab">
        <div id={Common.chain_HomeTabList[HomeTabList__Component__Loader].param_value} className="active" >
          {React.createElement(
            Common.chain_HomeTabList[HomeTabList__Component__Loader].element,
            props
          )}
        </div>
      </div>
    </>
  );
};

export default HomePageTabsListing;
